import { Fragment, ReactElement } from 'react';
import PersonSipoNonResidentPage from 'mutation/pages/registration-civil-union/non-resident/edit-person';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface PersonCivilUnionNonResidentNotificationSharedProps {
  goBackUrl?: string;
  redirectUrl?: string;
  items?: BreadcrumbItem[];
}

const PersonCivilUnionNonResidentNotificationShared = ({
  goBackUrl,
  redirectUrl,
  items,
}: PersonCivilUnionNonResidentNotificationSharedProps): ReactElement => {
  return (
    <Fragment>
      <PersonSipoNonResidentPage
        redirectUrl={redirectUrl}
        goBackUrl={goBackUrl}
        breadcrumbItems={items}
      />
    </Fragment>
  );
};

PersonCivilUnionNonResidentNotificationShared.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default PersonCivilUnionNonResidentNotificationShared;
